import addonIcon from '../mixins/addon.js'

export default {
  data () {
    return {
      addons: [],
      addon_display: {
        meta: [],
        attachments: []
      }
    }
  },
  methods: {

    drawAddons () {
      var self = this

      self.addonsloading = true

      if (self.addons.length) {
        self.clearMarkers()
      }

      for (var i = 0; i < self.campaign.addons.length; i++) {
        var addon = self.drawAddon(self.campaign.addons[i])
        addon.set('meta', self.campaign.addons[i].meta)
        addon.set('attachments', self.campaign.addons[i].media)
        self.addons.push(addon)
      }
    },

    drawAddon (addon) {
      var self = this
      var map = self.$refs.mainMap.$mapObject
      var icon = this.getAddonMarker(addon.rotation)

      var a = new window.google.maps.Marker({
        map: map,
        position: addon.coords,
        icon
      })

      a.addListener('click', function (event) {
        self.addon_display.meta = this.get('meta')
        self.addon_display.attachments = this.get('attachments')
        self.addon_panel_show = true
      })
      return a
    },

    getAddonMarker (rotation) {
      return {
        path: addonIcon,
        fillColor: '#ef7d00',
        fillOpacity: 1,
        scale: 0.4,
        strokeWeight: 0,
        anchor: new window.google.maps.Point(12, 0),
        rotation: rotation
      }
    },

    clearMarkers () {
      var self = this
      while (self.addons.length) {
        var addons = self.addons.shift()
        addons.setMap(null)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/drawAddons.js